import { useMenuTrigger } from '@react-aria/menu';
import { useMenuTriggerState } from '@react-stately/menu';
import { useTreeState } from '@react-stately/tree';
import React__default, { useRef, useMemo } from 'react';
import { useMenuList, SwanMenuListContext } from './menu-list.context.js';
import { SwanMenuTriggerContext } from './menu-trigger.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { useDarkModeExtractor } from '../../hooks/use-dark-mode-extractor.js';
import { SwanPopoverContextProvider, useSwanPopover } from '../popover/popover.context.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SwanMenuContextProviderInner(props) {
    const { children, onAction } = props;
    const { triggerRef, triggerProps, overlayState } = useSwanPopover();
    const { menuTriggerProps, menuProps } = useMenuTrigger(_object_spread_props(_object_spread({}, triggerProps), {
        type: 'menu'
    }), overlayState, triggerRef);
    const menuTriggerContextValue = useMemo(()=>({
            triggerProps: menuTriggerProps,
            triggerDisabled: false
        }), [
        menuTriggerProps
    ]);
    const menuRef = React__default.useRef(null);
    const { childItems, items, disabledKeys } = useCollectionContext();
    const menuState = useTreeState(_object_spread_props(_object_spread({}, menuProps), {
        items,
        disabledKeys,
        children: childItems
    }));
    const menuListContextValue = useMenuList(_object_spread_props(_object_spread({}, menuProps), {
        onAction
    }), menuRef, menuState);
    return /*#__PURE__*/ React__default.createElement(SwanMenuTriggerContext.Provider, {
        value: menuTriggerContextValue
    }, /*#__PURE__*/ React__default.createElement(SwanMenuListContext.Provider, {
        value: menuListContextValue
    }, children));
}
function SwanMenuContextProvider(props) {
    const menuTriggerState = useMenuTriggerState({});
    const popoverRef = useRef(null);
    const triggerRef = useRef(null);
    const hasDarkMode = useDarkModeExtractor(triggerRef, menuTriggerState.isOpen);
    const popoverContext = useMemo(()=>({
            popoverRef,
            triggerRef,
            overlayState: menuTriggerState,
            overlayProps: {},
            triggerProps: {},
            hasDarkMode
        }), [
        popoverRef,
        triggerRef,
        menuTriggerState,
        hasDarkMode
    ]);
    return /*#__PURE__*/ React__default.createElement(SwanPopoverContextProvider, {
        value: popoverContext
    }, /*#__PURE__*/ React__default.createElement(SwanMenuContextProviderInner, props));
}

export { SwanMenuContextProvider };
